import Environment from '@utilities/environment';

import { getPrefixedUrl } from '../get-prefixed-url';
const POSTCODE_ENDPOINT = '/umbraco/surface/Postcode/LookupAddress';

interface PostcodeCheckerInterface {
    postcode: string;
    houseNumber: string;
    houseNumberAddition?: string;
}

type PostcodeCheckerResponse = {
    Street: string;
    StreetNen: string;
    HouseNumber: string;
    HouseNumberAddition: string;
    Postcode: string;
    City: string;
    CityShort: string;
    Municipality: string;
    MunicipalityShort: string;
    Province: string;
    RdX: string;
    RdY: string;
    Latitude: number;
    Longitude: number;
    BagNumberDesignationId: string;
    BagAddressableObjectId: string;
    AddressType: string;
    Purposes: string[];
    SurfaceArea: string;
    HouseNumberAdditions: string[];
};

const requestAddress = async ({
    postcode,
    houseNumber,
    houseNumberAddition,
}: PostcodeCheckerInterface) => {
    let url = getPrefixedUrl(POSTCODE_ENDPOINT);
    url += `?postcode=${postcode}`;
    url += `&houseNumber=${houseNumber}`;
    if (houseNumberAddition) url += `&houseNumberAddition=${houseNumberAddition}`;

    const response = await fetch(url)
        .then((res) => res.json())
        .catch((err) => !Environment.isProduction && console.error(err));

    if (!response) return;
    return response as PostcodeCheckerResponse;
};

export { requestAddress, PostcodeCheckerInterface };
